import React from 'react';
import styles from './map-controls.css';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';

function CenterFocusButton({
    mapRef,
    activeGeoJsonLayer,
    onLayerChange,
    rectanguloByLayerName = {
        "KAIROS:EU_025_live_demo": [[73, -27], [33, 45]],
        "KAIROS:EU_0125_live_demo": [[60, -10], [36, 25]]
    }
}) {
    const resetMapView = () => {
        if (mapRef?.current) {
            const bounds = rectanguloByLayerName[activeGeoJsonLayer] || [[73, -27], [33, 45]];
            mapRef.current.fitBounds(bounds);

            if (onLayerChange) {
                onLayerChange(null);
            }
        }
    };

    return (
        <div className={styles.container} onClick={resetMapView}>
            <CenterFocusStrongIcon />
        </div>
    );
}

export default CenterFocusButton;
